import React from 'react';
import styled, { keyframes } from 'styled-components';
import closeIcon from '../../asset/img/common/close_icon2.svg';
import speaker from '../../asset/img/common/speaker_icon.svg';
import Button from '../../components/common/Button';

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: scale(0.8);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
`;

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1002;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const DialogContainer = styled.div`
  background-color: white;
  border-radius: 16px;
  width: calc(100% - 32px);
  max-width: 360px;
  animation: ${fadeIn} 0.2s ease-out;
  z-index: 1003;
  box-shadow: 0px 4px 15px 0px rgba(0, 0, 0, 0.25);

  padding: 16px 16px 48px 16px;
`;

const Title = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  gap: 16px;
`;

const CloseIcon = styled.div`
  display: flex;
  justify-content: flex-end;
`;

const InfoBox = styled.div`
  background-color: #f5f5f5;
  border-radius: 8px;
  padding: 16px;
  margin-top: 16px;
`;

const InfoBoxTitle = styled.div`
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  margin-bottom: 12px;
  color: #333;
`;

const InfoRow = styled.div`
  font-size: 13px;
  font-weight: 400;
  line-height: 20px;
  color: #555;
  margin-bottom: 4px;
  white-space: pre-wrap;
`;

const FooterText = styled.div`
  font-size: 13px;
  font-weight: 400;
  line-height: 20px;
  color: #555;
  margin-top: 16px;
  text-align: center;
  white-space: pre-wrap;
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 24px;
`;

const ServiceDisruptionAlert = ({ onClose }) => {
  return (
    <Overlay onClick={onClose}>
      <DialogContainer onClick={e => e.stopPropagation()}>
        <CloseIcon onClick={onClose}>
          <img src={closeIcon} alt="닫기" />
        </CloseIcon>
        <Title>
          <div className="displayFlex" style={{ gap: '8px', justifyContent: 'flex-start' }}>
            <img style={{ width: '24px' }} src={speaker} alt="상담 서비스 중단 안내" />
            <div className="subtitleBold">상담 서비스 일시 중단 안내</div>
          </div>
          <div
            className="body2Medium"
            style={{ whiteSpace: 'pre-wrap', textAlign: 'left', padding: '0 16px' }}>
            현재{' '}
            <span style={{ fontWeight: '600', fontSize: '14px' }}>채팅상담 및 전화상담 서비스</span>
            에 일시적인 장애가 발생하여 정상적인 이용이 어려운 상태입니다.
          </div>
        </Title>
        <InfoBox>
          <InfoBoxTitle>■ 장애 현황</InfoBoxTitle>
          <InfoRow>영향 서비스: 채팅상담, 전화상담</InfoRow>
          <InfoRow>
            복구 예정:{' '}
            <span style={{ fontWeight: '600', fontSize: '13px' }}>
              금일(2월 2일) 내 복구 완료 예정
            </span>
          </InfoRow>
          <InfoRow>
            {`현재 빠른 복구를 위해 최선을 다하고 있으며, 오늘 중으로 정상화될 예정입니다.\n이용에 불편을 드려 죄송합니다.\n감사합니다.`}
          </InfoRow>
        </InfoBox>
        <ButtonContainer>
          <Button value="확인" onClick={onClose} fullWidth />
        </ButtonContainer>
      </DialogContainer>
    </Overlay>
  );
};

export default ServiceDisruptionAlert;
